module.exports = __webpack_public_path__ + "img/suitcase-rolling.da2d1de8.svg";